export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/stop-icon.svg?ad9bb391b8fa3c8ce16955edbb961d8f";